import { defineStore } from 'pinia';

export const usePuzzleStore = defineStore('puzzleStore', {
  state: () => ({
    puzzles: [],
    blunders: [],
    tactics: {},      
    openings: [],    
    currentIndex: 0,
    currentBlunderIndex: 0,
    solvedArray: {
      right: 0,
      wrong: 0,
    },
    showAnalysis: false,
  }),
  getters: {
    currentPuzzle(state) {
      if (state.currentIndex >= 0 && state.currentIndex < state.puzzles.length) {
        return state.puzzles[state.currentIndex];
      }
      return null;
    },
    totalPuzzles(state) {
      return state.puzzles.length;
    },
    solvedPercentage(state) {

      const total = state.solvedArray.right + state.solvedArray.wrong;
      if (total === 0) {
        return 0;
      }
      return Math.round((state.solvedArray.right / total) * 100);
    },
    tacticsPerformance(state) {
      return Object.entries(state.tactics)
        .map(([name, stats]) => ({
          name: name.replace(/_/g, " "), 
          spotted: stats.spotted,
          total: stats.total,
          percentage: stats.total > 0 
            ? Math.round((stats.spotted / stats.total) * 100) 
            : 0
        }))
        .sort((a, b) => {
          if (b.percentage !== a.percentage) {
            return b.percentage - a.percentage;
          }
          return b.total - a.total;
        });
    },
    currentBlunder(state) {
      if (state.currentBlunderIndex >= 0 && state.currentBlunderIndex < state.blunders.length) {
        return state.blunders[state.currentBlunderIndex];
      }
      return null;
    },
    totalBlunders(state) {
      return state.blunders.length;
    },
  },
  actions: {
    setAnalysisData(payload) {
      this.puzzles = payload.puzzles || [];
      this.blunders = payload.blunders || [];
      this.tactics = payload.tactics || {};
      this.openings = payload.openings || [];
      this.currentIndex = 0;
      this.currentBlunderIndex = 0;
      this.solvedArray = {
        right: 0,
        wrong: 0,
      };
    },

    setShowAnalysis(bool) {
      this.showAnalysis = bool;
    },

    nextPuzzle() {
      if (this.currentIndex < this.puzzles.length - 1) {
        this.currentIndex++;
        return true; 
      }
      return false; 
    },
    markPuzzleSolved(wasSolved) {
      if (wasSolved) {
        this.solvedArray.right++;
      } else {
        this.solvedArray.wrong++;
      }
    },
    nextBlunder() {
      if (this.currentBlunderIndex < this.blunders.length - 1) {
        this.currentBlunderIndex++;
        return true; 
      }
      return false; 
    },
  },
});